import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './en/common.json';
import frCommon from './fr/common.json';
import enBooking from './en/booking.json';
import frBooking from './fr/booking.json';
import enAdmin from './en/admin.json';
import frAdmin from './fr/admin.json';
import enMarketing from './en/marketing.json';
import frMarketing from './fr/marketing.json';
import enLegal from './en/legal.json';
import frLegal from './fr/legal.json';

const savedLang = localStorage.getItem('app_language');
const supported = ['en', 'fr'];
const initialLang = supported.includes(savedLang) ? savedLang : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        booking: enBooking,
        admin: enAdmin,
        marketing: enMarketing,
        legal: enLegal
      },
      fr: {
        common: frCommon,
        booking: frBooking,
        admin: frAdmin,
        marketing: frMarketing,
        legal: frLegal
      }
    },
    lng: initialLang,
    fallbackLng: 'en',
    ns: ['common', 'booking', 'admin', 'marketing', 'legal'],
    defaultNS: 'common',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
